export default "__VITE_ASSET__BJbxEC1h__"